'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { NotificationTargetTabs } from '../-components/NotificationTargetTabs';
import { NotificationPoliciesTable } from './-components/NotificationPoliciesTable';
export const Route = createFileRoute('/_staff/settings/notification-and-response/_layout/notification-policies/')({
  component: NotificationPolicies
});
function NotificationPolicies() {
  return <NotificationTargetTabs>
      <NotificationPoliciesTable />
    </NotificationTargetTabs>;
}